<main class="login-page d-flex justify-content-center px-3 pt-2">
    <section class="login-panel w-100">
        <header class="login-header d-flex flex-column mb-4">
            <h3 class="p-0 mb-0">Welkom bij Dirk</h3>
            <h6 class="p-0 mb-0">De app van D. van der Steen B.V.</h6>
            <p class="mb-0">Via deze app kunt u onze werkzaamheden volgen en eventuele problemen melden.</p>
        </header>

        <section class="login-section d-flex flex-column mb-4">
            <h6 class="p-0 mb-0">Heeft u al een account voor de Dirk-app?</h6>
            <mat-radio-group
                (change)="changeRegister()"
                [(ngModel)]="register"
                class="login-radio-group d-flex flex-column">
                <mat-radio-button [value]="true">Ik heb nog geen account</mat-radio-button>
                <mat-radio-button [value]="false">Ik heb al wel een account</mat-radio-button>
            </mat-radio-group>
        </section>

        @if (register) {
            <section class="login-section d-flex flex-column mb-4">
                <h6 class="p-0 mb-0">Hoe bent u betrokken met onze organisatie?</h6>
                <mat-radio-group
                    [(ngModel)]="usertype"
                    (change)="customerProject = null"
                    class="login-radio-group d-flex flex-column">
                    <mat-radio-button value="consumer">Als bewoner in de omgeving van een project</mat-radio-button>
                    <mat-radio-button value="client">Als opdrachtgever</mat-radio-button>
                    <mat-radio-button value="employee">Als medewerker</mat-radio-button>
                </mat-radio-group>
            </section>

            @if (usertype === 'consumer') {
                <section class="login-section d-flex flex-column mb-4">
                    <h6 class="p-0 mb-0">In de omgeving van welk project woont u?</h6>
                    <mat-radio-group
                        [(ngModel)]="customerProject"
                        class="login-radio-group projectsradio d-flex flex-column">
                        @for (project of customerProjects; track project.id) {
                            <mat-radio-button [value]="project">
                                {{ project.name }}<br />
                                <small>{{ project.customer_name }}</small>
                            </mat-radio-button>
                        }
                    </mat-radio-group>

                    @if (customerProject) {
                        <div class="login-actions d-flex flex-column mt-1">
                            <button
                                [routerLink]="[
                                    '/',
                                    Routenames.register,
                                    customerProject.customer_id,
                                    customerProject.id,
                                ]"
                                class="w-100"
                                color="primary"
                                mat-raised-button>
                                Account aanmaken
                            </button>
                        </div>
                    }
                </section>
            } @else if (usertype === 'employee') {
                <section class="login-section d-flex flex-column mb-4">
                    <h5 class="p-0 mb-0">Account aanmaken voor de Dirk-app</h5>
                    <p class="mb-0">
                        Als medewerker kun je geen account voor jezelf aanmaken.<br />
                        Vraag een collega om een account voor je aan te maken.
                    </p>
                </section>
            } @else if (usertype === 'client') {
                <section class="login-section d-flex flex-column mb-4">
                    <h5 class="p-0 mb-0">Account aanmaken voor de Dirk-app</h5>
                    <p class="mb-0">
                        Als opdrachtgever is het niet mogelijk zelf te registreren.<br />
                        Vraag uw contactpersoon bij DvdSteen om een account aan te maken.
                    </p>
                </section>
            }
        } @else {
            <form [formGroup]="loginForm" (ngSubmit)="login()" class="login-form d-flex flex-column">
                <section class="login-section d-flex flex-column mb-4">
                    <div class="d-flex flex-column">
                        <h5 class="p-0 mb-0">Inloggen met e-mailcode</h5>
                        <p class="mb-0 text-muted">Vul je e-mailadres in om een inlogcode te ontvangen.</p>
                    </div>

                    <div class="login-fields d-flex flex-column">
                        <mat-form-field class="w-100">
                            <input
                                formControlName="email"
                                id="email"
                                matInput
                                name="email"
                                placeholder="E-mailadres"
                                (blur)="normalizeEmail()"
                                type="email" />
                        </mat-form-field>
                    </div>

                    @if (loginFormState === LoginFormState.FillInPassword) {
                        <mat-form-field id="password" appearance="fill">
                            <mat-label>Wachtwoord</mat-label>
                            <input
                                formControlName="password"
                                autocomplete="current-password"
                                matInput
                                name="password"
                                placeholder="Wat is uw wachtwoord?"
                                type="password" />
                            @if (loginForm.invalid) {
                                <mat-error>Vul uw wachtwoord in</mat-error>
                            }
                        </mat-form-field>
                    }

                    @if (errorMessage) {
                        <div class="login-actions message mt-0">{{ errorMessage }}</div>
                    }

                    @if (loginFormState === LoginFormState.FillInPassword || loginForm.get('password')?.value) {
                        <button (click)="forgotPassword()" mat-button type="button">Wachtwoord vergeten</button>
                    }

                    @if (loginFormState === LoginFormState.FillInPassword) {
                        <button
                            class="w-100"
                            color="primary"
                            (click)="loginWithPassword()"
                            mat-raised-button
                            type="submit">
                            Inloggen
                        </button>
                    } @else if (loginFormState !== LoginFormState.MsLogin) {
                        <div class="login-actions d-flex flex-column mt-0">
                            <button
                                [disabled]="loginForm.invalid || loginFormState === LoginFormState.RequestingCode"
                                class="w-100"
                                color="primary"
                                mat-raised-button>
                                @if (loginFormState === LoginFormState.RequestingCode) {
                                    We sturen je nu een code
                                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                } @else {
                                    Code opvragen
                                }
                            </button>
                        </div>
                    }

                    @if (loginFormState !== LoginFormState.MsLogin) {
                        <div class="login-divider d-flex align-items-center text-muted">
                            <span class="flex-grow-1"></span>
                            <small class="px-3">of</small>
                            <span class="flex-grow-1"></span>
                        </div>
                    }

                    <div class="login-actions d-flex flex-column mt-0">
                        <button
                            (click)="loginWithMicrosoft()"
                            [class.highlight]="loginFormState === LoginFormState.MsLogin"
                            class="microsoft-login-btn w-100"
                            mat-raised-button
                            type="button">
                            <mat-icon fontSet="fa-brands" fontIcon="fa-microsoft"></mat-icon>
                            Inloggen met Microsoft
                        </button>
                    </div>

                    @if (loginFormState === LoginFormState.MsLogin) {
                        <div class="info">
                            <b>Gebruik "Inloggen met Microsoft"</b>
                            <p>Inloggen met Microsoft is verplicht voor dit e-mailadres.</p>
                        </div>
                    }
                </section>
            </form>
        }
    </section>
</main>
